import { initializeApp } from '@firebase/app'
import {
  initializeAnalytics,
  logEvent,
  setUserId,
  setUserProperties,
  Analytics
} from '@firebase/analytics'
import { getEnvConfig } from 'utils/getEnvConfig'

let analytics: Analytics | null = null
let initialized = false
let debugMode = false

export const FirebaseAnalytics = {
  init: () => {
    if (initialized) {
      return
    }
    if (typeof window === 'undefined') {
      return
    }
    initialized = true
    try {
      const isMissing = (v: unknown) => !v || v === 'undefined' || v === 'null'
      const apiKey = getEnvConfig('FIREBASE_API_KEY')
      const appId = getEnvConfig('FIREBASE_APP_ID')
      const projectId = getEnvConfig('FIREBASE_PROJECT_ID')
      if (isMissing(apiKey) || isMissing(appId) || isMissing(projectId)) {
        return
      }
      const firebaseConfig: Record<string, string> = {
        apiKey,
        authDomain: getEnvConfig('FIREBASE_AUTH_DOMAIN'),
        projectId,
        storageBucket: getEnvConfig('FIREBASE_STORAGE_BUCKET'),
        messagingSenderId: getEnvConfig('FIREBASE_MESSAGING_SENDER_ID'),
        appId
      }
      const measurementId = getEnvConfig('FIREBASE_MEASUREMENT_ID')
      if (!isMissing(measurementId)) {
        firebaseConfig.measurementId = measurementId
      }
      const app = initializeApp(firebaseConfig)

      analytics = initializeAnalytics(app)

      // Enable debug mode for Firebase DebugView via URL param ?debug_mode=true
      if (window.location.search.includes('debug_mode=true')) {
        debugMode = true
      }
    } catch (e) {
      console.warn('Firebase Analytics not available — events will be logged to console', e)
    }
  },
  logEvent: (eventName: string, params?: Record<string, any>) => {
    const sanitizedName = eventName.replace(/\s+/g, '_').substring(0, 40)
    const sanitizedParams = params
      ? Object.fromEntries(
          Object.entries(params).map(([key, value]) => [
            key.replace(/\s+/g, '_').substring(0, 40),
            value
          ])
        )
      : undefined
    if (analytics) {
      const eventParams = debugMode ? { ...sanitizedParams, debug_mode: true } : sanitizedParams
      logEvent(analytics, sanitizedName, eventParams)
    }
  },
  setUserId: (id: string) => {
    if (analytics) {
      setUserId(analytics, id)
    }
  },
  setUserProperties: (props: Record<string, string>) => {
    if (analytics) {
      setUserProperties(analytics, props)
    }
  }
}
